import React, { useContext } from 'react';

export const BannerContext = React.createContext(0);

export const useBannerVisiblityFinder: any = () => {
	const bannerHeight: number = useContext(BannerContext);

	return bannerHeight;
};
